import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {pairwise, startWith} from "rxjs/operators";
import {CoreService} from "../../../../../services/core/core.service";

@Component({
    selector: 'app-bid-step-preview',
    templateUrl: './bid-step-preview.component.html',
    styleUrls: ['./bid-step-preview.component.scss'],
    standalone: false
})
export class BidStepPreviewComponent implements OnInit {

  @Input() model: any = {};
  @Input() isEdit: boolean = false;
  @Input() form: any = {};
  @Input() step: any;
  @Output() callback = new EventEmitter<any>(true);

  public bidDetail:any = {};
  public scopesStage:any = {};
  public assignment:any = {};
  public jobsiteAddressDetail:any = {};


  constructor(
    public coreService: CoreService
  ) { }

  public onModelValueChanged:any = {};


  ngOnChanges(changes: SimpleChanges) {
  }

  ngOnInit(): void {
    this.model = this.model?.model;
    this.form.get('step01').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.bidDetail = next?.bidDetail;
      });

    this.form.get('step02').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.scopesStage = next?.scopesStage;
      });

    this.form.get('step03').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.assignment = next?.assignment;
      });

    this.form.get('step04').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.jobsiteAddressDetail = next?.jobsiteAddressDetail;
      });
  }

}
